import { useState } from "react";
import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import type { BulkActionConfirmationModalProps } from "./types";

export const BulkActionConfirmationModal = ({
  isOpen,
  onClose,
  onSubmit,
  selectedEntityCount,
  title,
  confirmationText,
  testId,
}: BulkActionConfirmationModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) {
    return null;
  }

  const entityLabel = selectedEntityCount === 1 ? "entity" : "entities";

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalV2
      show={isOpen}
      onHide={onClose}
      title={title}
      description={`${selectedEntityCount} selected ${entityLabel}`}
      data-testid={testId}
    >
      <ModalV2.Body>
        <Text variant="regular-md">{confirmationText}</Text>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end" gap={SPACING.SMALL}>
          <Button variant="neutral" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
            Submit for approval
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
